// 默认渠道号
export const DEFAULT_CHANNEL = 'xubei';
// 默认客服系统地址
export const DEFAULT_SYSTEM_URL = 'https://cschat-ccs.aliyun.com/index.htm?tntInstId=_1l45OHI&scene=SCE00006146';

// 使用新首页的域名
export const NEW_HOME_DOMAIN_NAME = [
	'm.xubei.cc',
	'm.xubei.org',
	'm.rfspeed.com',
	'xb.hzmxwl.com',
	'sem.xubei.com',
	'mxubei.pengchengxinxi.cn',
	'mxubei.aizyd.cn',
	'mxubei.yijukewenhua.cn',
	'mxubei.njlesba.cn',
	'mxubei.cdxfqa.top',
	'mxubei.hhzsmwlkj.cn',
	'mxubei.ziywl.cn',
	'mxubei.njblqs.com',
    'm1.xubei.com',
	'mxubei.ohwclp.cn'
];



// WEBPACK FOOTER //
// ./src/config/constants.js